// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._container ._entry-btn{touch-action:none;width:80px;height:40px;display:flex;background:#3b5bdb;border:1px solid hsla(0,0%,100%,.18);border-radius:4px;box-shadow:0 4px 14px rgba(15,30,80,.42);position:relative;z-index:1000;color:#f0f5ff;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
